/**
 * Summary
 * The MapContainer component is responsible for displaying the UI control
 * overlay, displaying a defined map (based on global context) and
 * adjusting the map display (coords centering, zoom) base on user
 * interactivity.
 */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useMaps, useApp } from "../_contexts";
import { MapViewport } from "./";
import { UIContainer } from "../UI";
import { EmptyChronicle } from "./EmptyChronicle";
import { getDefaultCoverImageURL } from "../_helpers";

export function MapContainer() {
  const { data: chronicle } = useSelector((state) => state.chronicle);
  const { items: maps } = useSelector((state) => state.maps);
  const { items: images } = useSelector((state) => state.images);
  const [cover, setCover] = useState(null);

  const { currentMap, loadMaps, goToMap, setCurrentMap, interactiveMode } =
    useMaps();
  const { editMode } = useApp();

  useEffect(() => {
    let image = "";
    if (chronicle && chronicle.defaultCover) {
      if (chronicle.defaultCover?._id) {
        image = chronicle.defaultCover?.url || "";
      } else {
        const coverImage = images.find((i) => i._id === chronicle.defaultCover);
        if (!coverImage) {
          image = getDefaultCoverImageURL();
        } else {
          image = coverImage.url;
        }
      }
    } else {
      image = getDefaultCoverImageURL();
    }
    if (
      image.indexOf("url(") !== 0 &&
      image.indexOf("http") === 0 &&
      image.length > 0
    ) {
      setCover(`url(${image})`);
    } else {
      setCover(image);
    }
    // console.log('FOUND COVER', cover);
  }, [chronicle]);

  // Map
  useEffect(() => {
    if (maps) {
      // console.log(maps);
      console.log("--- MAP: ", currentMap);
      if (currentMap !== null && currentMap !== undefined) {
        let map = maps.find((m) => m._id === currentMap._id);
        // goToMap(map, coords);
        setCurrentMap(map);
        return;
      }

      if (chronicle.defaultMap && currentMap === null) {
        // console.log("Loading Default Chronicle Map", chronicle.defaultMap);
        let searchTerm = "";
        if (chronicle.defaultMap && typeof chronicle.defaultMap === "string") {
          searchTerm = chronicle.defaultMap;
        } else if (chronicle.defaultMap._id) {
          searchTerm = chronicle.defaultMap._id;
        }
        const defaultMap = maps.find((m) => m._id === searchTerm);
        if (defaultMap) {
          // console.log("Found Map!", defaultMap);
          const coords = {
            x: defaultMap.options.coordX,
            y: defaultMap.options.coordY,
            z: defaultMap.options.zoomDefault,
          };
          goToMap(defaultMap, coords);
          // setCurrentMap(defaultMap);
          // setCoords(coords);
          // // goToMap(maps.find((m) => m._id === chronicle.defaultMap)._id)
        }
      } else {
        console.log("Loading fallback Map");
        if (maps && maps.length > 0) {
          // goToMap(maps[0]);
          const fallbackMap = maps[0];
          const coords = {
            x: fallbackMap.options.coordX,
            y: fallbackMap.options.coordY,
            z: fallbackMap.options.zoomDefault,
          };
          goToMap(fallbackMap, coords);
          // setCurrentMap(fallbackMap);
          // setCoords(coords);
        } else {
          console.log(
            `[Chronos] Error - Display Map: No default map set (Chronicle likely has no Maps).`
          );
        }
      }
      loadMaps(maps);
    }
  }, [maps]);

  const noCover = !cover || cover.length === 0;
  const isEditor = chronicle ? chronicle.isEditor : false;
  const showCover = !noCover && !currentMap;

  const classList = ["chronos-map-container"];
  if (interactiveMode) {
    classList.push("chronos-interactive-map-mode");
  }

  return (
    <div
      className={classList.join(" ")}
      style={{ backgroundImage: showCover ? cover : "" }}
    >
      <UIContainer />
      {currentMap && <MapViewport map={currentMap} />}
      {!currentMap && chronicle && !chronicle.setupComplete && (
        <EmptyChronicle
          editor={isEditor}
          chronicle={chronicle}
          editMode={editMode}
        />
      )}
    </div>
  );
}
